import { render, staticRenderFns } from "./images.vue?vue&type=template&id=52bb7d20"
import script from "./images.vue?vue&type=script&lang=js"
export * from "./images.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports